import { Injectable } from '@angular/core';
import { SyncOperation } from '@app/core';
import { GenericService } from '@messaia/cdk';
import { Observable } from 'rxjs';
import { OrderItem } from '../models/order-item';

@Injectable({ providedIn: 'root' })
export class OrderItemService extends GenericService<OrderItem> {

	/**
	 * Constructor
	 */
	constructor() {
		super('orderitem');
	}

	/**
	 * Schedule a sync for the order item with the specified ID
	 * @param id 
	 * @param operation 
	 */
	public scheduleSync(id: number, operation: SyncOperation): Observable<any> {
		return this.update(`scheduleSync/${id}/${operation}`, null);
	}
}